import React from 'react';
import { CircleHelp } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipTrigger } from 'components/ui/tooltip';

const SelfRegistrationSummary = ({ accounts, pilgrims }) => (
  <div className="min-w-0 sm:ml-auto" role="group" aria-label="Auto-inscriptions">
    <div className="flex flex-wrap items-center gap-x-6 gap-y-2 text-[13px]">
      <div className="flex items-center gap-1.5 font-medium text-slate-500">
        <span>Auto-inscriptions</span>
        <Tooltip>
          <TooltipTrigger asChild>
            <button
              type="button"
              aria-label="À propos des auto-inscriptions"
              className="rounded-full focus-visible:outline focus-visible:outline-2"
            >
              <CircleHelp className="h-3.5 w-3.5" />
            </button>
          </TooltipTrigger>
          <TooltipContent>
            Les pèlerins auto-inscrits sont déjà comptabilisés dans les statistiques de leur société agréée.
          </TooltipContent>
        </Tooltip>
      </div>
      <dl className="flex flex-wrap items-center gap-x-6 gap-y-2">
        {[
          ['Comptes auto-inscrits', accounts],
          ['Pèlerins auto-inscrits', pilgrims],
        ].map(([label, value]) => (
          <div key={label} className="flex items-baseline gap-2">
            <dt className="text-slate-500">{label}</dt>
            <dd className="text-base font-semibold leading-none text-slate-900">{value.toLocaleString('fr-FR')}</dd>
          </div>
        ))}
      </dl>
    </div>
  </div>
);

export default SelfRegistrationSummary;
